import React from 'react';
import { Modal, Input, Spin, Empty } from 'antd';
import { searchImages } from '../../services/imageService';

function ImagePicker({ open, onClose, onSelect }) {
    const [q, setQ] = React.useState('indian food');
    const [loading, setLoading] = React.useState(false);
    const [results, setResults] = React.useState([]);

    const runSearch = async (query) => {
        setLoading(true);
        try {
            const items = await searchImages(query);
            setResults(items);
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        if (open) runSearch(q);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return (
        <Modal
            title="Search Images"
            open={open}
            onCancel={onClose}
            footer={null}
            width={900}
        >
            <div className="space-y-4">
                <Input.Search
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                    onSearch={(value) => runSearch(value || q)}
                    placeholder="Search free images (Pexels/Unsplash)"
                    enterButton
                />
                {loading ? (
                    <div className="py-12 text-center"><Spin /></div>
                ) : results.length === 0 ? (
                    <Empty description="No images found" />
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-h-[60vh] overflow-auto">
                        {results.map((img) => (
                            <button
                                key={img.id}
                                onClick={() => onSelect?.(img)}
                                className="group relative rounded-lg overflow-hidden border border-slate-200 hover:shadow-md transition"
                            >
                                <img src={img.thumb} alt="preview" className="w-full h-36 object-cover" />
                                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20" />
                                <div className="absolute bottom-0 left-0 right-0 text-[11px] text-white/90 px-2 py-1 bg-gradient-to-t from-black/50 to-transparent">
                                    {img.source} · {img.author}
                                </div>
                            </button>
                        ))}
                    </div>
                )}
                <div className="text-xs text-slate-500">
                    Tip: Set API keys in localStorage as VITE_PEXELS_API_KEY and VITE_UNSPLASH_ACCESS_KEY.
                </div>
            </div>
        </Modal>
    );
}

export default ImagePicker;


